import axiosInstance from './axiosInstance';

const getSubscriptionInfo = async ({ token }) => {
  try {
    const response = await axiosInstance.post(
      '/subscriptioninfo',
      {},
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('Error posting data: ' + error.message);
  }
};

export {getSubscriptionInfo};